import {
    DOCUMENT_ALLOWED_FILE_EXTENSIONS,
    type DocumentAllowedFileExtension,
} from './document-file.constants';

export function pickDocumentExtension<E extends DocumentAllowedFileExtension>(
    ext: E
): E;
export function pickDocumentExtension(
    ext: string
): DocumentAllowedFileExtension;
export function pickDocumentExtension(
    ext: string
): DocumentAllowedFileExtension {
    const found = DOCUMENT_ALLOWED_FILE_EXTENSIONS.find(e => e === ext);
    if (!found) {
        throw new Error(
            `Expected "${ext}" in DOCUMENT_ALLOWED_FILE_EXTENSIONS`
        );
    }
    return found;
}
